"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CowriterSearchHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "This page displays a list of your co-writers along with the number of songs you've written together, making it easier to track your collaborations at a glance.")));
exports.default = CowriterSearchHeader;
